t = require('views/internal/teacup-with-helpers')('reactions')
View = require 'view'
joinn = require 'joinn'

formattedName = (name) ->
  t.render ->
    t.span '.reaction-fullname', ->
      t.text name

formattedReaction = (reaction) ->
  t.render ->
    t.strong ->
      t.text reaction

template = t.renderable ({ names, reaction }) ->
  names = names.map formattedName
  t.div '.reaction-tooltip', ->
    if names != '' && !reaction?
      t.raw (joinn names, ', ', " #{ t.l 'and' } ")
    else if names.length == 1
      t.raw t.l 'reaction-tooltip', {
        name: names[0],
        reaction: formattedReaction (reaction)
      }, { raw: true }
    else if names.length > 1
      t.raw t.l 'reaction-tooltip-plural', {
        names: (joinn names, ', ', " #{ t.l 'and' } "),
        reaction: formattedReaction (reaction)
      }, { raw: true }
    else
      t.raw formattedReaction (reaction)

module.exports = class ReactionTooltip extends View
  renderOnce: ->
    { names, reaction } = @options
    names ?= []

    @$el.append template { names, reaction }
    @



// WEBPACK FOOTER //
// ./app/scripts/views/reactions/reaction-tooltip.coffee